<p-chip
    [label]="label"
    [styleClass]="styleClass"
></p-chip>